const pickBy = (obj) => {
  return Object.keys(obj).filter((k) => obj[k] != null).reduce((a, k) => ({ ...a, [k]: obj[k] }), {})
}

const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export {
  pickBy,
  sleep
}